export default __webpack_public_path__ + "static/media/GMC_logo_light.ed919160.png";